<template>
  <div class="dangJianShe">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="是否组织参赛" ref="is_cansai" prop="is_cansai">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_cansai" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="tips">
                <i class="iconfont icon-xinxitishi"></i>注：
                是否组织学员参加科技类竞赛，包括区级、省级、区域级、全国、国际等线上及线下赛事
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="ruleForm.is_cansai == 1">
          <el-form-item label="参赛名称" ref="cansai_name" prop="cansai_name">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.cansai_name" multiple placeholder="请选择" class="inp">
                <el-option
                  v-for="item in cansaiOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="是否组织研学活动" ref="is_yanxue" prop="is_yanxue">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.is_yanxue" placeholder="请选择" class="inp">
                <el-option
                  v-for="item in isYes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="ruleForm.is_yanxue == 1">
          <el-form-item label="研学区域" ref="quyu" prop="quyu">
            <div class="flex justify-start align-center">
              <el-select v-model="ruleForm.quyu" multiple placeholder="请选择" class="inp">
                <el-option
                  v-for="item in yanxuequyuOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="ruleForm.cansai_name.indexOf(7) != -1">
        <div class="flex align-center" v-for="(item,index) in ruleForm.qita_saishi_name" :key="item.id">
          <el-col :span="10">
            <el-form-item label="赛事名称"
                          :ref="'qita_saishi_name.' + index + '.name'"
                          :prop="'qita_saishi_name.' + index + '.name'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.name" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="赛事组织方"
                          :ref="'qita_saishi_name.' + index + '.zuzhi'"
                          :prop="'qita_saishi_name.' + index + '.zuzhi'"
                          :rules="{
                                required: false, message: '请输入', trigger: 'blur'
                              }">
              <div class="flex justify-start align-center">
                <el-input v-model="item.zuzhi" class="inp"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <img src="@/assets/images/tianjiaicon.png" v-if="index == 0" class="add" @click="addSs()" alt="">
            <img src="@/assets/images/jianhaoicon.png" v-else class="add" @click="delSs(index)" alt="">
          </el-col>
        </div>
      </el-row>
    </el-form>
    <div class="btn-box center">
      <div class="btn" @click="submitForm('ruleForm',1)">临时保存参赛信息</div>
      <div class="btn margin-left-xs" @click="submitForm('ruleForm',2)">提交参赛信息</div>
    </div>
    <div class="btn-box">
      <div class="btn" @click="dialogVisible = true">添加月末未消课时</div>
    </div>
    <div class="list ">
      <el-table
        :data="tableData"
        :header-cell-style="centerbgc"
        :cell-style="textCenter"
        style="width: 100%">
        <el-table-column
          label="月末在册学员人数"
          prop="student_num"
          width="150">
        </el-table-column>
        <el-table-column
          label="月末未消课时数量"
          prop="class_num">
        </el-table-column>
        <el-table-column
          width="200"
          prop="money"
          label="月末未消课时金额（元）">
        </el-table-column>
        <el-table-column
          label="操作"
          width="250">
          <template slot-scope="scope" class="flex">
            <div class="edit pointer" @click="edit(scope)">编辑</div>
            <div class="del pointer" @click="del(scope)">删除</div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page-box">
      <el-pagination
        :current-page.sync="search.page"
        :page-size="search.limit"
        :total="search.total"
        background
        class="page-all margin-top self-end"
        layout="prev, pager, next"
        @current-change="list">
      </el-pagination>
    </div>

    <jiaoxueDialog :dialogVisible="dialogVisible" :id="id" @handleClose="handleClose" />
  </div>
</template>
<script>
import jiaoxueDialog from "@/views/home/orgOperation/dialog/jiaoxueDialog";
import {scrollIntoView} from "@/utils/utils";
import {cansaiOptions, isYes, yanxuequyuOptions} from "@/utils/const";
import {del_xueyuan, get_yunying, save_jiaoxue, xueyuan_lst} from "@/api";
export default {
  name: "jiaoxue",
  data() {
    return {
      isYes: isYes,
      cansaiOptions: cansaiOptions,
      yanxuequyuOptions:yanxuequyuOptions,
      dialogVisible:false,
      id:'',
      tableData:[],
      search:{
        page: 1,
        limit: 10,
        total:0
      },
      ruleForm: {
        is_cansai: '', // 是否组织参赛
        cansai_name: [], // 参赛名称
        is_yanxue: '', // 是否组织研学活动
        quyu: [], // 研学区域
        qita_saishi_name: [{
          name: '',
          zuzhi: '',
          id: Date.now(),
        }], // 赛事名称
      },
      rules: {
        is_yanxue: [
          {required: false, message: '请选择', trigger: 'change'}
        ] ,
        quyu: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
        cansai_name: [
          {required: false, message: '请选择', trigger: 'change'}
        ] ,
        is_cansai: [
          {required: false, message: '请选择', trigger: 'change'}
        ],
      }
    }
  },
  components: {jiaoxueDialog},
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.init()
    this.list()
  },
  methods: {
    async init(){
      let _data = await get_yunying(4);
      if(_data.status == 200){
        this.ruleForm = {
          is_cansai: _data.data.is_cansai, // 是否组织参赛
          cansai_name: _data.data.cansai_name ? _data.data.cansai_name.split(',').map(Number) : [], // 参赛名称
          is_yanxue: _data.data.is_yanxue, // 是否组织研学活动
          quyu: _data.data.quyu ? _data.data.quyu.split(',').map(Number) : [], // 研学区域
          qita_saishi_name: _data.data.qita_saishi_name ? _data.data.qita_saishi_name : [{
            name: '',
            zuzhi: '',
            id: Date.now(),
          }] // 赛事名称

        }
      }
    },

    submitForm(formName,zancun) {
      if(zancun == 1) {
        this.submitInfo(zancun)
      }else {
        this.$refs[formName].validate((valid, validates) => {
          if (valid) {
            this.submitInfo(zancun)
          } else {
            scrollIntoView(this, validates)
          }
        });
      }
    },

    async submitInfo(zancun) {
      let _data = await save_jiaoxue(
        zancun,
        this.ruleForm.is_cansai,
        this.ruleForm.cansai_name.join(','),
        this.ruleForm.is_yanxue,
        this.ruleForm.quyu.join(','),
        JSON.stringify(this.ruleForm.qita_saishi_name),
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
      } else {
        this.$message.error(_data.msg)
      }
    },
    // 获取列表
    async list() {
      let _data = await xueyuan_lst(
        this.search.page,
        this.search.limit
      );
      if (_data.status == 200) {
        this.tableData = _data.data.data
        this.search.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },

    handleClose(){
      this.dialogVisible = false
      this.id = ''
      this.list()
    },
    edit(scope){
      this.id = scope.row.id
      this.dialogVisible = true
    },
    del(scope) {
      this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.expertDel(scope.row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    async expertDel(id){
      let _data = await del_xueyuan(id);
      if(_data.status == 200){
        this.$message.success(_data.msg)
        this.list()
      } else {
        this.$message.error(_data.msg)
      }
    },

    addSs() {
      this.ruleForm.qita_saishi_name.push({
        name: '',
        zuzhi: '',
        id: Date.now()
      })
    },
    delSs(index) {
      this.ruleForm.qita_saishi_name.splice(index, 1)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {
  .width {
    width: 400px;
  }
  .edit {
    font-size: 14px;
    color: #0089ff;
    padding: 4px 10px;
    display: inline-block;
  }
  .del {
    font-size: 14px;
    color: #ff0000;
    padding: 4px 10px;
    display: inline-block;
  }
  .title-flex {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;

    b {
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .add {
    width: 30px;
    cursor: pointer;
    margin-top: 12px;
  }

  .inp {
    flex: 1;
  }

  .tips {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    background-color: #fef0ef;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 14px;
    color: #f34336;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 16px;

    i {
      font-size: 20px;
      color: #f34336;
      margin-right: 4px;
    }

    &.width {
      width: 160px;
    }
  }

  .look {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    border: 1px solid #2791ff;
    color: #2791ff;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    margin-left: 10px;
    border-radius: 4px;
  }

  .btnUp {
    width: max-content;
    padding: 0 10px;
    height: 36px;
    margin-left: 10px;
    background-image: linear-gradient(90deg,
      #2791ff 0%,
      #81b6ff 100%);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;

    i {
      font-size: 20px;
      color: #ffffff;
      margin-right: 5px;
      font-weight: 100;
    }
  }

  .btn-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    &.center {
      justify-content:  center;
    }

    .btn {
      width: max-content;
      padding: 0 12px;
      height: 36px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 6px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>


